import { TournamentFormatForm } from "./components/TournamentFormatForm";

export function CreateTournamentFormatPage() {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="mb-6">
        <h2 className="text-2xl font-bold">Crear Evento de Torneo</h2>
        <p className="text-gray-600 mt-1">
          Define un nuevo evento disponible para los torneos.
        </p>
      </div>
      <TournamentFormatForm />
    </div>
  );
}
